// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"BizTeamList_componentStyle__QnxTz","item":"BizTeamList_item__Vt5Yq"};